import { Icon } from './bootstrap'
import { tr } from 'react-hook-form-auto'

export const BSUtils = {
  renderAddContent: () => {
    return <Icon icon="plus" text={tr("add")} />
  }
}
